import { render, staticRenderFns } from "./applyDelete.vue?vue&type=template&id=6278878a&scoped=true"
import script from "./applyDelete.vue?vue&type=script&lang=js"
export * from "./applyDelete.vue?vue&type=script&lang=js"
import style0 from "./applyDelete.vue?vue&type=style&index=0&id=6278878a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278878a",
  null
  
)

export default component.exports